import { get } from "./base-api";

// bookings list
export const getBookingList = (page: number, size: number) => {
  return get(`/booking?size=${size}&page=${page}`);
};
